import React, { useState, useEffect } from 'react';
import {
    Form, Tag, Button, Card, Space, message,
    Table, Typography, Divider, Alert, Select
} from 'antd';
import {
    DatabaseOutlined, BackwardOutlined,
    ReloadOutlined, FileTextOutlined
} from '@ant-design/icons';
import useWebPost from '../../utils/useWebPost';

const { Title, Text } = Typography;
const { Option } = Select;


const DBBackupPage = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [backupFiles, setBackupFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState('');
    const webPost = useWebPost();

    useEffect(() => {
        fetchBackupFiles();
    }, []);

    const fetchBackupFiles = async () => {
        try {
            const res = await webPost('getDbc');
            if (res) {
                setBackupFiles(res);
            }
        } catch (error) {
            message.error('获取备份文件失败：' + error.message);
        }
    };

    // 2. 执行数据库备份
    const handleBackup = async () => {
        try {
            setLoading(true);
            const res = await webPost('setDbc');
            if (res) {
                message.success('备份成功！备份文件');
                fetchBackupFiles();
            }
        } catch (error) {
            message.error('备份请求异常：' + error.message);
        } finally {
            setLoading(false);
        }
    };

    // 3. 执行数据库恢复
    const handleRestore = async () => {
        if (!selectedFile) {
            message.warning('请选择要恢复的备份文件！');
            return;
        }
        try {
            setLoading(true);
            const res = await webPost(`resDb`, { backupFile: selectedFile });
            if (res) {
                message.success('恢复成功！');
                setSelectedFile('');
            }
        } catch (error) {
            message.error('恢复请求异常：' + error.message);
        } finally {
            setLoading(false);
        }
    };
    const columns = [
        {
            title: '备份文件名',
            dataIndex: 'fileName',
            key: 'fileName',
            ellipsis: true, // 超长文件名省略
        },
        {
            title: '文件大小',
            dataIndex: 'fileSize',
            key: 'fileSize',
            render: (size) => `${size} KB`, // 格式化显示
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
        },
        {
            title: '操作',
            key: 'action',
            render: (_, record) => (
                <Space size="small">
                    <Button
                        type="link"
                        danger
                        onClick={() => setSelectedFile(record.filePath)}
                    >
                        选择恢复
                    </Button>
                </Space>
            ),
        },
    ];
    return (
        <div style={{ padding: '20px' }}>
            <Card
                title={<Title level={4} icon={<DatabaseOutlined />}>MySQL 数据库备份与恢复</Title>}
                bordered={true}
                style={{ maxWidth: 800, margin: '0 auto' }}
            >
                {/* 温馨提示 */}
                <Alert
                    message="操作提示"
                    description="恢复操作会覆盖当前数据库数据，请务必确认备份文件正确后再执行！"
                    type="warning"
                    showIcon
                    style={{ marginBottom: 20 }}
                />

                <Divider />

                {/* 操作按钮区 */}
                <Space size="middle">
                    <Button
                        type="primary"
                        icon={<BackwardOutlined />}
                        onClick={handleBackup}
                        loading={loading}
                    >
                        执行备份
                    </Button>
                    <Button
                        type="danger"
                        icon={<ReloadOutlined />}
                        onClick={handleRestore}
                        loading={loading}
                        disabled = {!selectedFile}
                    >
                        执行恢复
                    </Button>
                    <Button
                        icon={<FileTextOutlined />}
                        onClick={fetchBackupFiles}
                    >
                        刷新备份列表
                    </Button>
                </Space>

                <Divider />
                {selectedFile && (
                    <div style={{ marginTop: 10 }}>
                        <Tag color="blue">
                            已选择恢复文件：{selectedFile.split('/').pop()}
                        </Tag>
                    </div>
                )}
                <Divider />

                {/* 备份文件列表（替换为表格展示） */}
                <div style={{ marginTop: 10 }}>
                    <Title level={5}>备份文件列表</Title>
                    {backupFiles.length === 0 ? (
                        <Text type="secondary">暂无备份文件，请先执行备份操作</Text>
                    ) : (
                        <Table
                            columns={columns}
                            dataSource={backupFiles}
                            rowKey="filePath" // 唯一标识
                            pagination={{ pageSize: 10 }} // 分页
                            size="middle"
                        />
                    )}
                </div>
            </Card>
        </div>
    );
};

export default DBBackupPage;